import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const TokenSwapRouteFragment = graphql(
  `
    fragment TokenSwapRoute on TokenSwapActivity {
      fromToken {
        ...TokenPrice
      }
      toToken {
        ...TokenPrice
      }
    }
  `,
  [TokenPriceFragment],
)
